const Glass = () => {
  return <div className='glass'></div>;
};

export default Glass;
